import { useViewLeaveGuard } from '../../hooks/use-view-leave-guard'
import { hasDraftEdits, requiresExplicitSave, type ActionInlineDraft } from './inline-drafts'

/**
 * Leave guard over the inline drafts of a view's still-editable actions: any
 * edit holds back automatic navigation, and one that owes an explicit Save
 * sends user navigation through the save-changes dialog.
 */
export function useUnsavedChangesGuard(editableDrafts: Array<ActionInlineDraft | undefined>) {
  useViewLeaveGuard({
    hasEdits: editableDrafts.some(hasDraftEdits),
    needsConfirm: editableDrafts.some(requiresExplicitSave),
  })
}
